import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiKey, FiUsers, FiArrowRight, FiShield } = FiIcons;

const PrivateAccessLock = ({ memorial, onUnlock }) => {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passcode === memorial.passcode) {
      onUnlock();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-brand-light">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src={memorial.coverImage} className="w-full h-full object-cover blur-xl opacity-20 scale-110" alt="" />
      </div>

      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative z-10 w-full max-w-lg bg-white rounded-[40px] shadow-2xl border border-brand-dark overflow-hidden"
      >
        <div className="p-10 md:p-14 text-center">
          <div className="w-20 h-20 bg-accent-navy text-white rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-xl shadow-accent-navy/10">
            <SafeIcon icon={FiLock} className="w-10 h-10" />
          </div>
          
          <h2 className="text-3xl font-serif text-accent-navy mb-4">Private Sanctuary</h2>
          <p className="text-text-muted font-light mb-10 leading-relaxed">
            This memorial for <span className="font-bold text-accent-navy">{memorial.name}</span> is private. Please enter the family passcode to view the tributes and gallery.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className={`relative transition-transform ${error ? 'animate-shake' : ''}`}>
              <SafeIcon icon={FiKey} className="absolute left-5 top-1/2 -translate-y-1/2 text-accent-gold w-5 h-5" />
              <input 
                type="password" 
                placeholder="Enter Family Passcode"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                className="w-full pl-14 pr-6 py-5 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none text-lg font-bold tracking-widest text-accent-navy transition-all"
              />
            </div>
            
            {error && <p className="text-red-500 text-xs font-bold uppercase tracking-widest">Incorrect Passcode</p>}

            <button type="submit" className="w-full btn-primary py-5 text-lg flex items-center justify-center gap-3 group">
              Unlock Memorial <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>

          <div className="mt-12 pt-10 border-t border-brand-light">
            <p className="text-sm text-text-muted mb-6">Don't have a passcode?</p>
            {requestSent ? (
              <div className="bg-green-50 text-green-700 py-4 px-6 rounded-2xl flex items-center justify-center gap-3 font-bold border border-green-100">
                <SafeIcon icon={FiIcons.FiCheckCircle} /> Request Sent to Family
              </div>
            ) : (
              <button 
                onClick={() => setRequestSent(true)}
                className="flex items-center gap-3 mx-auto text-accent-navy font-bold hover:text-accent-gold transition-colors"
              >
                <SafeIcon icon={FiUsers} /> Request Invitation from Family
              </button>
            )}
          </div>
        </div>

        <div className="bg-brand-light p-6 flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-text-muted">
          <SafeIcon icon={FiShield} className="w-4 h-4 text-accent-gold" /> Protected by OneFinalLegacy Privacy
        </div>
      </motion.div>
    </div>
  );
};

export default PrivateAccessLock;